
import {Component, Vue} from 'vue-property-decorator';
import {RouterNameEnum} from '@/router/router.types';
import PageTitle from '@/UI/components/common/PageTitle.vue';
import BaseDataForm from '@/UI/components/Helpers/BaseForm/BaseDataForm.vue';
@Component({components: {PageTitle, BaseDataForm}})
export default class SettingsIndex extends Vue {
  get canManage(): boolean { return Vue.auth.check('owner') || Vue.auth.check('admin'); }
  get groups(): any[] {
    const params = {Studio: this.$route.params.Studio || String(this.$store.state.salon_id || 0)};
    return [
      {title: 'Компания', items: [
        {title: 'Профиль компании', description: 'Название, описание и контактные данные бизнеса.', icon: 'shop', to: '/Settings/company'},
        {title: 'Подписка компании', description: 'Пробный период, срок доступа и продление.', icon: 'credit-card', to: '/Settings/subscription'},
      ]},
      {title: 'Команда и доступ', items: [
        {title: 'Пользователи', description: 'Управляющие и администраторы: роли и филиалы.', icon: 'team', to: {name: RouterNameEnum.SettingsUsers, params}},
        {title: 'Доступ мастеров', description: 'Вход сотрудников в мобильное приложение.', icon: 'mobile', to: {name: RouterNameEnum.SettingsRolesAndAccess, params}},
      ]},
      {title: 'Категории и источники', items: [
        {title: 'Категории клиентов', description: 'Группы клиентов для вашей компании.', icon: 'tags', to: {name: RouterNameEnum.SettingsCategoriesClients}},
        {title: 'Источники', description: 'Откуда клиенты узнают о ваших филиалах.', icon: 'notification', to: {name: RouterNameEnum.SettingsCategoriesSource}},
      ]},
    ];
  }
}
